<template>
  <div class="footer">
    <div class="logo">
      <img src="../img/impresso/Tutilabs-logo.svg" alt="" />
      <img src="../img/impresso/logo-tuti.png" alt="" />
    </div>
  </div>
  <p style="text-align: end">RRIM-TUTIPLAST-8.3-01-Rev.: 02</p>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  border-bottom: 2px solid #636363;
}

.logo {
  width: 100%;
  height: 2rem;
  display: flex;
  justify-content: space-between;
}
.logo img {
  height: 100%;
}
</style>